import React, {useRef} from 'react';
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import FilterDropdown from './FilterDropdown';
import { applyFilter } from '../../actions/SamplePage';


const theme = createMuiTheme({
	palette: {
		primary: { 500: '#DA1B2C' },
	}

});



const StyledMenu = withStyles({
	paper: {
		boxShadow: '1px 2px 3px #d3d4d5',
	},
})(props => (
	<Menu
		elevation={0}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'center',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'center',
		}}
		{...props}
	/>
));



function Filter({ years, states, subjects, value, applyFilter, language }) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [year, setYear] = React.useState("");
	const [state, setState] = React.useState("");
	const [subject, setSubject] = React.useState("");
	const yrRef = useRef(null)
	const stateRef = useRef(null)
	const subRef = useRef(null)
	const {filterBy, allMenuDropdown, filterLabelYear, filterLabelState, filterLabelSubject} = language;

	function handleClick(event) {
		setAnchorEl(event.target);
	}

	function handleClose() {
		setYear(value.year);
		setState(value.state);
		setSubject(value.subject);
		yrRef.current.reset()
		stateRef.current.reset()
		subRef.current.reset()
		setAnchorEl(null);
	}

	const onDropdowChange = (data) => {
		switch (data.name) {
			case "years":
				return setYear(data.value);
			case "states":
				return setState(data.value);
			case "subjects":
				return setSubject(data.value);
			default:
				console.log("Not valid name in filter")
		}
	}

	const onApply = () => {
		applyFilter({ year, state, subject });
		setAnchorEl(null);
	}
	return (
		<div className="pull-left filter-by-dropdown">
			<button aria-controls="customized-menu"
				aria-haspopup="true" onClick={handleClick}
				variant="contained" ><span className="filter-menu-icon"></span>{filterBy}</button>
			<StyledMenu
				id="customized-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose} className="filter-by-dropdown-menu"
			>
				<form autoComplete="off">
					<FilterDropdown ref={yrRef} selected={value.year} data={years} id="years" 
						placeholder={filterLabelYear} onChange={onDropdowChange} blankMenuLabel={allMenuDropdown}/>
					<FilterDropdown ref={stateRef} selected={value.state} data={states} id="states" 
						placeholder={filterLabelState} onChange={onDropdowChange} blankMenuLabel={allMenuDropdown}/>
					<FilterDropdown ref={subRef} selected={value.subject} data={subjects} id="subjects" 
						placeholder={filterLabelSubject} onChange={onDropdowChange} blankMenuLabel={allMenuDropdown}/>

				</form>
				<div className="filter-action-buttons">
					<Button variant="contained" onClick={handleClose} className="create-account-button">Cancel</Button>
					<ThemeProvider theme={theme}>
						<Button onClick={onApply} variant="contained" className="login-button" color="primary">Apply</Button>
					</ThemeProvider>
				</div>
			</StyledMenu>
		</div>
	);
}

const mapStateToProps = (state, ownProp) => {
	const filter = state.SamplePage.filter
	const {filterBy, allMenuDropdown, filterLabelYear, filterLabelState, filterLabelSubject} = state.Language;
	return { ...filter, language :{filterBy, allMenuDropdown, filterLabelYear, filterLabelState, filterLabelSubject}};
}

const mapDispatchToProps = (dispatch) => {
	return {
		applyFilter: (filter) => dispatch(applyFilter(filter))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Filter);